import { trackAuctionNotEnoughMoneyPopupPayClick } from './tracking';

export function handlePayClick() {
  trackAuctionNotEnoughMoneyPopupPayClick();

  location.href = 'https://my.cian.ru/pay';
}
